<template>
	<div class="proposal-view">
		<notifications />
        <preloader v-if="isLoading"></preloader>
		<section class="heading">
			<h1 class="title">{{ proposal.number ? proposal.number : "ESTIMATE/PTABS/2019/02/100" }}</h1>
		</section>
		<section class="subheading">
			<div class="row">
				<div class="col-xs-12 col-sm-8 proposal-action-section">
					<router-link class="btn-proposal-action" :to="relativeUrl(`/proposals/${this.$route.params.id}/edit`)">Edit</router-link>
					<a class="btn-proposal-action" @click="convertToInvoice">Convert To Invoice</a>
					<a class="btn-proposal-action" @click="printProposal">Customer View</a>
				</div>
				<div class="col-xs-12 col-sm-4 text-right">
					<a class="btn btn-primary" @click="sendEmail" :disabled="isLoading">
						<i v-show="isLoading" class="fa fa-circle-o-notch fa-spin"></i>
						SEND<span v-if="isValidDate(proposal.last_sent_email_at)">, Last sent <time-ago :datetime="`${proposal.last_sent_email_at}`"></time-ago></span> 
					</a>
					<more-action-button id="dropdownMenu1">
						<ul class="dropdown-menu" aria-labelledby="dropdownMenu1">
							<li><router-link :to="relativeUrl(`/proposals/create?duplicate_id=${this.$route.params.id}`)">Duplicate</router-link></li>
							<li><a href="#" @click="remove()">Delete</a></li>
						</ul>
					</more-action-button>
				</div>
			</div>
		</section>
		<section class="main" id="printable">
			<print-preview :proposal="proposal"></print-preview>
		</section>
	</div>
</template>

<script>
import { relativeUrl, displayDate, isValidDate } from '../../helpers';
import { defaultFields } from "./helpers";
import PrintPreview from './PrintPreview.vue';
import printJS from "print-js";
import MoreActionButton from "../MoreActionButton";
import TimeAgo from "vue2-timeago";
import Preloader from "../Preloader.vue"

export default {
	components: { PrintPreview, MoreActionButton, TimeAgo, Preloader },
	data() {
		return {
			proposal: defaultFields(),
			isLoading: false,
			baseUrl: null,
		}
	},
	async beforeMount() {
		this.isLoading = true;

		try {
			const proposalResponse = await axios.get(`/proposals/${this.$route.params.id}`);
            this.proposal = this.parseData(proposalResponse.data.data);
            // console.log(this.proposal);
			window.document.title = this.proposal.number;
		} catch {
			this.$notify({
				type: 'error',
				title: 'Oops!',
				text: 'Sorry, an error occured!'
			})
		}

		this.isLoading = false;
	},
	mounted() {
		this.baseUrl = window.$('meta[name="base-url"]').attr('content');
	},
	methods: {
		relativeUrl, isValidDate,
		parseData(item) {
			return {
				...item,
				payment_terms: JSON.parse(item.payment_terms),
			}
		},
		printProposal() {
			// Pass the element id here
			// this.$htmlToPaper('printable', () => {
			// 	console.log('Printing done or got cancelled!');
			// });

			printJS({
				printable: 'printable', type: 'html', scanStyles: false, showModal: true,
				css: [
					`${this.baseUrl}/css/bootstrap.min.css`,
					`${this.baseUrl}/css/AdminLTE.min.css`,
					`${this.baseUrl}/css/print.css`,
				],
				documentTitle: this.proposal.number
			});
			console.log(this.proposal.number)
		},
		async sendEmail() {
			this.isLoading = true;

			try {
				await axios.post(`/proposals/${this.$route.params.id}/email`);
				this.$notify({
					type: 'success',
					title: 'Sent!',
					text: 'Congratulations, email sent!'
				})
			} catch {
				this.$notify({
					type: 'error',
					title: 'Oops!',
					text: 'Sorry, an error occured!'
				})
			}

			this.isLoading = false;
		},
		convertToInvoice() {
			window.location.href = relativeUrl(`/invoices/create?proposal_id=${this.$route.params.id}`);
		},
		async remove() {
			this.isLoading = true;

			try {
				const response = await axios.delete(`/proposals/${this.$route.params.id}`);
				window.location.href = relativeUrl(`/proposals`);
				this.$notify({
					type: 'success',
					title: 'Proposal Deleted!',
					text: 'You\'ve deleted the proposal!'
				})
			} catch {
				this.$notify({
					type: 'error',
					title: 'Oops!',
					text: 'Sorry, an error occured!'
				})
			}

			this.isLoading = false;
		},
	}
}
</script>
